import { render } from "./mac.vue?vue&type=template&id=c6ea918c&ts=true"
import script from "./mac.vue?vue&type=script&lang=ts"
export * from "./mac.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__